import appList from './app-list.js'

export default function () {
  const currentRoute = window.location.hash
  let activeAppID = appList[appList.length - 1].id // Select last app as fallback, in case no other is activated
  let returnNow = false

  for (const app of appList) {
    if (returnNow || !app.isActive()) {
      // If another app had been activated or the current is not active at all, stop checking
      break
    }
    for (const route of app.activeUnder) {
      // For each 'activeUnder' item, check if app should be active
      if (currentRoute.startsWith(`#/${route}`)) {
        activeAppID = app.id
        returnNow = true
        break
      }
    }
  }

  return activeAppID
}
